/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import jobStyles from "./jobStyles";
import SendApplication from "./SendApplication";
import TextContainer from "../../Container/TextContainer";
import { Helmet } from "react-helmet-async";
import Layout from "../../../containers/Layouts/Layout";
import { gaSet } from "../../../services/cookieService";
import Typography from "@mui/material/Typography";
import HeadlineSection from "../../Sections/Generic/HeadlineSection/HeadlineSection";
import cvImage from "../../../assets/img/jobs/cv.svg";
import { attorneyDosAndDonts } from "../../../services/jobs/jobsService";
import { Box } from "@mui/material";
import DoAndDont from "./DoAndDont";
import AreYouInterestedSection from "./AreYouInterestedSection";

const Attorney = () => {
  const title = "Jobs - Rechtsanwältin/Rechtsanwalt | Legalbird";
  gaSet({ title: title });

  return (
    <Layout backgroundType={"landingpage"}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <HeadlineSection headline={"Rechtsanwältin / Rechtsanwalt (m/w/d)"} image={cvImage} />
      <TextContainer sx={jobStyles.container}>
        <Typography variant={"h4"} textAlign={"center"}>
          Du bist (angehender) Rechtsanwalt (w/d/m)? Warum eine Legal-Tech-Kanzlei dein nächster Karriereschritt sein sollte!
        </Typography>
        <Typography paragraph>
          Du hast dich lange auf deine berufliche Zukunft vorbereitet und möchtest einen Job, der dich von Anfang an begeistert? Dir gefällt die Tätigkeit als
          Anwalt, aber du willst nicht 60 Stunden die Woche arbeiten? Du bist es leid, vom obligatorischen Obstkorb und halbjährlich stattfindenden
          Kanzleifeiern für einen Job “überzeugt” zu werden?
        </Typography>
        <Typography paragraph>Komm zu uns und starte deine Karriere in einer Legal-Tech-Kanzlei im Verbraucherrecht!</Typography>
        <Typography paragraph>
          Das Verbraucherrecht ist ein spannendes und schnelllebiges Rechtsgebiet, das in den letzten Jahren immer mehr an Bedeutung gewonnen hat. Es umfasst
          alle Rechtsfragen, die sich aus der Beziehung zwischen Verbrauchern und Unternehmen ergeben. Als Anwalt im Verbraucherrecht arbeitest du mit einer
          Vielzahl von Fällen und Mandanten und kannst bei wiederkehrenden Problemen größere Strategien entwickeln!
        </Typography>
        <Typography paragraph>
          Eine Legal-Tech-Kanzlei bietet viele Vorteile. Vor allem wirst du Teil eines engagierten Teams von Anwälten sein, die alle dasselbe Ziel verfolgen:
          Verbrauchern zu ihrem Recht zu verhelfen. Durch unsere fortgeschrittene Automatisierung ist es uns möglich, eine Vielzahl von Mandanten zu
          unterstützen. In unserem motivierenden Kanzleiumfeld lernst du von Anfang an, deine Mandate selbstständig zu bearbeiten und Verantwortung zu
          übernehmen.
        </Typography>
        <Typography paragraph>
          Lerne Legalbird kennen und sei dabei, wenn wir nicht nur den Rechtsmarkt, sondern auch die Arbeitsbedingungen für Rechtsanwälte revolutionieren!
        </Typography>
        <Typography variant={"h4"} textAlign={"center"} sx={{ marginTop: 6 }}>
          DOs and DON'Ts - Was uns bei Legalbird von klassischen Kanzleien unterscheidet
        </Typography>
        {attorneyDosAndDonts.map((attorneyDoAndDont) => (
          <Box sx={{ marginY: 6 }}>
            <DoAndDont
              doHeadline={attorneyDoAndDont.doHeadline}
              doText={attorneyDoAndDont.doText}
              dontHeadline={attorneyDoAndDont.dontHeadline}
              dontText={attorneyDoAndDont.dontText}
            />
          </Box>
        ))}
        <AreYouInterestedSection jobTitle={"Rechtsanwalt"} />
      </TextContainer>
      <SendApplication to={"RA Frank Riedel und RAin Anna Wagner"} />
    </Layout>
  );
};

export default Attorney;
